var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckboxIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 0.5H17C19.7612 0.5 22 2.73877 22 5.5V17.5C22 20.2612 19.7612 22.5 17 22.5H5C2.23877 22.5 0 20.2612 0 17.5V5.5C0 2.73877 2.23877 0.5 5 0.5ZM6 2C3.79102 2 2 3.79102 2 6V17C2 19.209 3.79102 21 6 21H16C18.209 21 20 19.209 20 17V6C20 3.79102 18.209 2 16 2H6Z",
    fill: "#FF7A00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxIcon);
export default __webpack_public_path__ + "static/media/checkboxIcon.6bd549ef7f24f2d4fc74ae3fbc9ffa3a.svg";
export { ForwardRef as ReactComponent };